<div class="app-map-box unselectable container-fluid">
  <div class="row">
    <div class="col-md">
      <div id="geoMap"></div>
      <div class="location-paginator">
        <mat-paginator
          hidePageSize
          [length]="config.dataSource.meta.totalItems"
          [pageSize]="config.dataSource.meta.itemsPerPage"
          (page)="onPaginationChange($event)"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>